export var NullLogger = {
  debug: function () {},
  error: function () {},
  info: function () {},
  trace: function () {},
  warn: function () {}
};
export function getNullLogger() {
  return NullLogger;
}